const selectors = ({ get, set }) => ({
    getToken: () => {
        return get('token');
    },
    getRole: () => {
        const userData = get('userData');
        return userData.role ? userData.role.roleType : '';
    },
    getPermissions: () => {
        const userData = get('userData');
        return userData.role ? userData.role.permissions : [];
    },
    getUserLoading: () => {
        const token = get('token');
        const userData = get('userData');
        const userLoading = get('userLoading');

        // Show loading if:
        // 1. Token exists (authenticated)
        // 2. userData missing required fields
        // 3. User data is loading
        return token &&
               (!userData || !userData.name || !userData.surname) &&
               userLoading;
    },

    /**
     * Auto-fetch selector for projects data
     * Returns { data, isLoading, error, refetch }
     */
    getProjectsData: () => {
        const projects = get('projects');
        const isLoading = get('projectsLoading');
        const error = get('projectsError');

        return {
            data: projects,
            isLoading,
            error,
            refetch: () => {
                return get('refetchProjects');
            },
        };
    },

    /**
     * Auto-fetch selector for user data
     * Returns { data, isLoading, error, refetch }
     */
    getUserMeData: () => {
        const userData = get('userData');
        const isLoading = get('userLoading');
        const error = get('userError');

        return {
            data: userData,
            isLoading,
            error,
            refetch: () => {
                return get('refetchUserData');
            },
        };
    },

    /**
     * Auto-fetch selector for project team
     * Returns { data, isLoading, error, refetch }
     */
    getProjectTeamData: () => {
        const team = get('team');
        const isLoading = get('teamLoading');
        const error = get('teamError');

        return {
            data: team,
            isLoading,
            error,
            refetch: (projectId) => {
                return get('refetchProjectTeam', projectId);
            },
        };
    },

    /**
     * Auto-fetch selector for current project
     * Returns { data, isLoading, error, refetch }
     */
    getCurrentProjectData: () => {
        const currentProject = get('currentProject');
        const isLoading = get('currentProjectLoading');
        const error = get('currentProjectError');

        return {
            data: currentProject,
            isLoading,
            error,
            refetch: (projectId) => {
                return get('fetchProject', projectId);
            },
        };
    },

    /**
     * Auto-fetch selector for project cue sheet
     * Returns { data, isLoading, error, refetch }
     */
    getCueSheetData: () => {
        const cueSheet = get('cueSheet');
        const isLoading = get('cueSheetLoading');
        const error = get('cueSheetError');

        return {
            data: cueSheet,
            isLoading,
            error,
            refetch: (projectId) => {
                return get('refetchCueSheet', projectId);
            },
        };
    },
})

export default selectors;
